import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchDynamicPackages', request, cancelToken)
}

export {get}
